document.addEventListener("DOMContentLoaded", ()=>{
     const menuLinks = JSON.parse(document.getElementById("shop-menu").textContent);
const headerImages = JSON.parse(document.getElementById("header-images").textContent);
const currentUrlPath = window.location.pathname;

const menuLinksWithImages = menuLinks.map((link) => {
  const fallbackImage = headerImages.find(
    (img) =>
      img.category?.toLowerCase() === link.title?.toLowerCase() &&
      img.is_fallback_image == "true"
  );

  return {
    title: link.title,
    url: link.url,
    links: link.links.map((l) => {
        const matchedImage = headerImages.find((img) => {
            const match =
            img.category.toLowerCase() === link.title?.toLowerCase() &&
            img.text && img.text.toLowerCase() === l.title.toLowerCase();

            return match;
      });

      return {
        title: l.title,
        url: l.url,
        default_image: matchedImage?.default_image || fallbackImage?.default_image || null,
        hover_image: matchedImage?.hover_image || fallbackImage?.hover_image || null,
      };
    }),
  };
});



    const currentCategoryIndex = menuLinksWithImages.findIndex((link)=>link.url == currentUrlPath || link.links.some((l)=>l.url == currentUrlPath))
    let currentSubCategoryIndex = -1
    if (currentCategoryIndex != -1){
        currentSubCategoryIndex = menuLinksWithImages[currentCategoryIndex]?.links.findIndex((l)=>l.url == currentUrlPath)
    }

    const currentSubCategory = currentSubCategoryIndex != -1 ? menuLinksWithImages[currentCategoryIndex].links[currentSubCategoryIndex] : null

    const menu = document.getElementById("collection-page__menu")
    menu.innerHTML = ``
    const menuTabs = document.createElement("div")
    menuTabs.className = "collection-page__menu-tabs"
    menuTabs.innerHTML = `
    <div class="page-width">
    <div class="collection-page__menu-tabs__container">
        ${menuLinksWithImages.map((link, index)=>{
          return `<a href="${link.url}" class="collection-page__menu-tabs__link ${index == currentCategoryIndex? 'active': ''}" data-tab="${index}">${link.title}</a>`
        }).join("")}
      </div>
    </div>
    `
    menu.appendChild(menuTabs)
    const menuLinksContainer = document.createElement("div")
    menuLinksContainer.className = "collection-page__menu-links"
    menuLinksContainer.innerHTML = `
      <div class="collection-page__menu-links__container page-width">
        ${menuLinksWithImages.map((link, index)=>{
          return `
            <div class="collection-page__menu-links__category ${index == currentCategoryIndex ? 'active': ''}" data-tab="${index}">
              <div class="collection-page__menu-links__category-links">
               ${currentSubCategory && index == currentCategoryIndex ? 
                    `
                    <div class="collection-page__menu-links__active-category">
                        <a href="${currentSubCategory.url}" class="collection-page__menu-links__category-link">
                            <div class="collection-page__menu-links__category-link-image">
                                <div class="collection-page__menu-links__category-link-image-overlay"></div>
                                <img src="${currentSubCategory.default_image}" alt="${currentSubCategory.title}" class="collection-page__menu-links__category-link-image-default">
                                <img src="${currentSubCategory.hover_image}" alt="${currentSubCategory.title}" class="collection-page__menu-links__category-link-image-hover">
                            </div>
                            <div class="collection-page__menu-links__category-link-title">${currentSubCategory.title}</div>
                        </a>
                    </div>
                    <div class="collection-page__menu-links__category-border">
                    </div>
                    `
                    :
                    ``
                }
                <div class="collection-page__menu-links__category-nonactive-wrapper">
                 <button class="scroll-button prev">←</button>
                  <div class="collection-page__menu-links__category-nonactive">
                        ${link.links.map((l, i)=>{
                      if (i == currentSubCategoryIndex && index == currentCategoryIndex){
                          return ``
                      }
                    return `
                      <a href="${l.url}" class="collection-page__menu-links__category-link">
                        <div class="collection-page__menu-links__category-link-image">
                          <div class="collection-page__menu-links__category-link-image-overlay"></div>
                          <img src="${l.default_image}" alt="${l.title}" class="collection-page__menu-links__category-link-image-default">
                          <img src="${l.hover_image}" alt="${l.title}" class="collection-page__menu-links__category-link-image-hover">
                        </div>
                        <div class="collection-page__menu-links__category-link-title">${l.title}</div>
                      </a>
                    `
                  }
                  ).join("")}
                </div>
                 <button class="scroll-button next">→</button>
                </div>
            </div>
            </div>
          `
        }
        ).join("")}
      </div>
    `
    menu.appendChild(menuLinksContainer)

    const script = document.createElement("script")
    script.innerHTML = `
      const container = document.querySelector('.collection-page__menu-links__category.active .collection-page__menu-links__category-nonactive');
      const prevBtn = document.querySelector('.collection-page__menu-links__category.active .scroll-button.prev');
      const nextBtn = document.querySelector('.collection-page__menu-links__category.active .scroll-button.next');
      function updateButtonsVisibility() {
        const isOverflowing = container.scrollWidth > container.clientWidth;
        console.log(isOverflowing, nextBtn, prevBtn, container);
        if(isOverflowing){
          prevBtn.classList.add('show');
          nextBtn.classList.add('show');
        }else{
          prevBtn.classList.remove('show');
          nextBtn.classList.remove('show');
        }
      }

      function scrollByAmount(direction) {
        const amount = container.clientWidth / 2;
        container.scrollBy({
          left: direction * amount,
          behavior: 'smooth'
        });
      }

      prevBtn.addEventListener('click', () => scrollByAmount(-1));
      nextBtn.addEventListener('click', () => scrollByAmount(1));
      window.addEventListener('resize', updateButtonsVisibility);
      updateButtonsVisibility()
    `
    menu.appendChild(script)
  })